import type { FaireProductEntity } from "../../entity_types/product";

export const p_y8xrpn6rb4: FaireProductEntity = {
  token: "p_y8xrpn6rb4",
  type: "product",
  name: "Long Sleeve Sonia Sweater - Blue Pine (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/1f53314c827c08d8e48a75414b6657296bd7b524aced9093b47468aa33c62bf4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/528a030605bad8a5d0a594e04013e39e72a0c2b85048aaa389d96c5d9b180411.jpeg",
    "https://cdn.faire.com/fastly/d4b7d6f5826c09391b34cc55cf9299cc9b48dd4ea19e19f4ca6b9e7148c1d851.jpeg",
    "https://cdn.faire.com/fastly/83f9bd3d14050f95fec5fb828f46c19d77c1c9f09d10bf55bff202f9312580ae.jpeg"
  ],
  priceDollars: 116.1,
  description: "100% Cotton\n",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:31.116Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
